import { render, staticRenderFns } from "./AggiungiAttrezzatura.vue?vue&type=template&id=47da7e7a&"
import script from "./AggiungiAttrezzatura.vue?vue&type=script&lang=js&"
export * from "./AggiungiAttrezzatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports